$(document).ready(function(){

    // init Isotope
    var $grid = $('.product_collection').isotope({
      itemSelector: '.product',
      percentPosition: true,
      layoutMode: 'fitRows',
    });

    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout');
    });

    // store filter for each group
    var filters = {};

    $('.filters').on( 'click', '.btn', function( event ) {
      var $button = $( event.currentTarget );
      // get group key
      var $buttonGroup = $button.parents('.button-group');
      var filterGroup = $buttonGroup.attr('data-filter-group');
      // set filter for group
      filters[ filterGroup ] = $button.attr('data-filter');
      // combine filters
      var filterValue = concatValues( filters );
      // set filter for Isotope
      $grid.isotope({ filter: filterValue });

    });

    // change is-checked class on buttons
    $('.button-group').each( function( i, buttonGroup ) {
      var $buttonGroup = $( buttonGroup );
      $buttonGroup.on( 'click', 'button', function( event ) {
        $buttonGroup.find('.active').removeClass('active');
        var $button = $( event.currentTarget );
        $button.addClass('active');
      });
    });

    // flatten object by concatting values
    function concatValues( obj ) {
      var value = '';
      for ( var prop in obj ) {
        value += obj[ prop ];
      }
      return value;
    }

    // get Isotope instance
    var iso = $grid.data('isotope');

    // init Infinite Scroll
    $grid.infiniteScroll({
      path: '.pagination__next',
      append: '.product',
      outlayer: iso,
      status: '.scroller-status'
    });
 });